import {
  Typography,
  UploadInput,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { ITask } from 'src/pages/projects/projects.interfaces';
import { useDeleteTaskFile } from 'src/hooks/tasks/delete-task-file.hook';
import {
  InfoBlock,
  InfoElement,
  InfoContainer,
} from 'src/pages/projects/sub-pages/project-details/components/project-details-info/project-details-info.styles';
import { TimeStripesGridWrapper } from 'src/pages/projects/components/create-task/components/time-stripes-list/time-stripes-list.styles';

import TimeStripeBlock from './time-stripe-block.component';

const TaskListView = ({ task }: { task: ITask }) => {
  const { t } = useTranslation(['common', 'projects']);

  const deleteTaskFile = useDeleteTaskFile();

  const onFileDelete = (file: any) => {
    deleteTaskFile({ variables: { fileId: file.uid, taskId: task._id } });
  };

  return (
    <div>
      <InfoContainer>
        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">{t('projects:task.taskName')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{task.name}</Typography>
          </InfoElement>
          <InfoElement>
            <Typography weight="bold">{t('projects:task.taskPlannedHours')}:</Typography>
            <Typography
              fontColor={PLATFORM_THEME_COLORS.primary.grey}
            >{`${task.plannedHours} hr`}</Typography>
          </InfoElement>
        </InfoBlock>

        <InfoBlock>
          <InfoElement>
            <Typography weight="bold">{t('projects:task.note')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{task.notes}</Typography>
          </InfoElement>
        </InfoBlock>
        <div>
          <div>
            <Typography weight="bold">
              {t('projects:task.uploadedFile')}:{!task.files.length && ' -'}
            </Typography>
            <div>
              <UploadInput
                defaultFileList={task.files.map(file => ({
                  uid: file._id,
                  name: file?.filename || file.key,
                  url: file.location,
                }))}
                onRemove={onFileDelete}
              />
            </div>
          </div>
        </div>
      </InfoContainer>
      <br />
      <Typography
        weight="bold"
        fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}
        size={TYPOGRAPHY_SIZE.small}
      >
        {t('projects:labels.timeStripe')}
      </Typography>
      <br />
      <TimeStripesGridWrapper>
        {task.timeStripes.map((timeStripe, index) => (
          <TimeStripeBlock timeStripe={timeStripe} key={index} />
        ))}
      </TimeStripesGridWrapper>
    </div>
  );
};

export default TaskListView;
